export default __webpack_public_path__ + "static/rsz_pg_logo_kolor-300x213-696953a2188125476fd533284213b313.jpg";